import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from '../pages/Home'
import Art from '../pages/services/Art'
import Business from '../pages/services/Business'
import Coaching from '../pages/services/Coaching'
import Design from '../pages/services/Design'
import Ecommerce from '../pages/services/Ecommerce'
import Finance from '../pages/services/Finance'
import Gamedev from '../pages/services/Gamedev'
import Html from '../pages/services/Html'
import IOS from '../pages/services/IOS'
import Javascript from '../pages/services/Javascript'
import About from '../pages/About'
import Becomeaseller from '../pages/Becomeaseller'
import Sellers from '../pages/Sellers'
import Services from '../pages/Services'
import Tutorials from '../pages/Tutorials'
import Startselling from '../pages/sellingpages/Startselling'

function Router() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home/>}></Route>
                <Route path="/art" element={<Art/>}></Route>
                <Route path="/business" element={<Business/>}></Route>
                <Route path="/coaching" element={<Coaching/>}></Route>
                <Route path="/design" element={<Design/>}></Route>
                <Route path="/ecommerce" element={<Ecommerce/>}></Route>
                <Route path="/finance" element={<Finance/>}></Route>
                <Route path="/gamedev" element={<Gamedev/>}></Route>
                <Route path="/html" element={<Html/>}></Route>
                <Route path="/ios" element={<IOS/>}></Route>
                <Route path="/javascript" element={<Javascript/>}></Route>
                <Route path="/about" element={<About/>}></Route>
                <Route path="/become a seller" element={<Becomeaseller/>}></Route>
                <Route path="/sellers" element={<Sellers/>}></Route>
                <Route path="/services" element={<Services/>}></Route>
                <Route path="/tutorials" element={<Tutorials/>}></Route>
                <Route path="/startselling" element={<Startselling/>}></Route>
                {/* <Route path="/" element={}></Route> */}
                {/* <Route path="/" element={}></Route> */}
            </Routes>
        </BrowserRouter>
    )
}

export default Router
